import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  TimePicker,
  Tooltip,
  Typography,
  message,
  Form
} from 'antd';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import {
  CopyOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
// import { Form } from '@ant-design/compatible';
import moment from 'moment-timezone';
import { Option } from 'antd/lib/mentions';
import { channelAdminConfig } from '../skills_action';

const CustomizeModal = ({
  open,
  handleClose,
  selectedDays,
  setSelectedDays,
  setSelectedTimezone,
  selectedTimezone,
  handleConfigOffHours,
}) => {
  const { Text } = Typography;
  const timezones = moment.tz.names();
  const weekdays = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const onChange = (checkedValues) => {
    let daysSelected = selectedDays
      ? selectedDays.reduce((accumulator, day) => {
        const startsWithChecked = checkedValues.some((value) =>
          day.day.startsWith(value)
        );

        if (startsWithChecked) {
          accumulator.push(day);
        }

        return accumulator;
      }, [])
      : [];

    checkedValues.forEach((value) => {
      const dayExists =
        daysSelected && daysSelected.some((day) => day.day.startsWith(value));
      if (!dayExists) {
        daysSelected.push({
          day: value,
          data: [{ name: value }],
        });
      }
    });

    setSelectedDays(daysSelected);
  };

  const handleTimeChange = (time, timeString, day, dayData) => {
    let tempSelectedDays = [...selectedDays];
    const currentDay = tempSelectedDays.find((i) => i.day === day.day);
    const dayIndex = currentDay.data.findIndex((i) => i.name === dayData.name);

    currentDay.data[dayIndex].time = time;
    currentDay.data[dayIndex].timeString = timeString;
    if (currentDay.data[dayIndex].error) {
      delete currentDay.data[dayIndex].error;
    }
    setSelectedDays(tempSelectedDays);
  };

  const handleAddSubTiming = (day, dayData) => {
    let tempSelectedDays = [...selectedDays];
    const currentDay = tempSelectedDays.find((i) => i.day === day.day);
    const dayIndex = currentDay.data.findIndex((i) => i.name === dayData.name);
    const dayName = dayData.name.split('-')[0];
    currentDay.data.splice(dayIndex + 1, 0, {
      name: `${dayName}-sub-${new Date().getTime()}`,
    });
    setSelectedDays(tempSelectedDays);
  };

  const handleDeleteSubTiming = (day, dayData) => {
    let tempSelectedDays = [...selectedDays];
    let currentDay = tempSelectedDays.find((i) => i.day === day.day);
    currentDay.data = currentDay.data.filter((i) => i.name !== dayData.name);
    setSelectedDays(tempSelectedDays);
  };

  const handleTimeZoneChange = (timezone) => {
    const offset = moment.tz(timezone).format('Z');
    setSelectedTimezone({ timezone, offset });
  };

  const handleCopyToAll = (day) => {
    if (day.data && day.data.every((val) => val.time && val.timeString)) {
      const replicatedArray = selectedDays.map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            data: [...day.data],
          };
        }
        return {
          ...item,
          data: day.data.map((timeConfig, idx) => {
            timeConfig.error && delete timeConfig.error;
            return {
              ...timeConfig,
              name:
                idx === 0
                  ? item.day
                  : `${item.day}-sub-${timeConfig.name.split('sub-')[1]}`,
            };
          }),
        };
      });
      setSelectedDays(replicatedArray);
    } else {
      const timesForOthers = selectedDays.filter((i) => i.day !== day.day);
      let errorFields = day.data.map((val) => {
        if (!val.time && !val.timeString) {
          return { ...val, error: true };
        }
        return val;
      });
      day.data = errorFields;
      setSelectedDays([day, ...timesForOthers]);
    }
  };

  return (
    <Modal
      title={'Configure Off hours'}
      visible={open}
      onCancel={handleClose}
      onOk={handleConfigOffHours}
      okText='Save'
      cancelText='Close'
      width={560}
    >
      <Form layout='vertical'>
        <div>
          <Text>Select days and time</Text>
          <Checkbox.Group
            options={weekdays.map((i) => i.substring(0, 3))}
            onChange={onChange}
            style={{ marginTop: 10 }}
            defaultValue={selectedDays.map((day) => day.day)}
          />
        </div>
        <div style={{ margin: '16px 0px 20px 0px' }}>
          {selectedDays &&
            selectedDays.map((day, mainIndex) =>
              day.data.map((dayData, index) => {
                const days = weekdays.find((i) => i.startsWith(dayData.name));
                const time =
                  dayData.time && dayData.time.map((time) => moment(time));
                return (
                  <div key={dayData.name}>
                    <Row
                      align='middle'
                      style={{ paddingTop: 8 }}
                      key={dayData.name}
                    >
                      <Col className='gutter-row' span={4}>
                        <Text>{days ? days : ''}</Text>
                      </Col>
                      <Col
                        className='gutter-row'
                        span={mainIndex === 0 && index === 0 ? 13 : 15}
                        style={{ display: 'flex' }}
                      >
                        <TimePicker.RangePicker
                          value={time}
                          allowClear={false}
                          format={'h:mm a'}
                          onChange={(time, timeString) => {
                            handleTimeChange(time, timeString, day, dayData);
                          }}
                          style={{ borderRadius: '2px', width: '240px' }}
                        />
                        {((index === 0 && day.data.length === 0) ||
                          index === day.data.length - 1) && (
                            <Button
                              type='text'
                              icon={
                                <PlusCircleOutlined
                                  style={{
                                    marginLeft: '1rem',
                                    ...(localStorage.getItem('theme') ==
                                      'default' && { color: '#00000073' }),
                                  }}
                                  onClick={() => {
                                    handleAddSubTiming(day, dayData);
                                  }}
                                />
                              }
                            />
                          )}
                        {index !== 0 && (
                          <Button
                            type='text'
                            icon={
                              <MinusCircleOutlined
                                style={{
                                  marginLeft: '1rem',
                                  ...(localStorage.getItem('theme') ===
                                    'default' && { color: '#00000073' }),
                                }}
                                onClick={() => {
                                  handleDeleteSubTiming(day, dayData);
                                }}
                              />
                            }
                          />
                        )}
                      </Col>
                      {mainIndex === 0 && index === 0 && (
                        <Col className='gutter-row' span={5}>
                          <Button
                            type='link'
                            icon={<CopyOutlined />}
                            onClick={() => {
                              handleCopyToAll(day);
                            }}
                          >
                            Copy time to all
                          </Button>
                        </Col>
                      )}
                      {dayData.error && (
                        <Text type='danger' style={{ marginLeft: '5.5rem' }}>
                          Fill or remove this field
                        </Text>
                      )}
                    </Row>
                  </div>
                );
              })
            )}
        </div>
        <div>
          <Text>Select time zone</Text>
          <Select
            placeholder='Select timezone'
            style={{ marginTop: 10, borderRadius: '2px' }}
            onChange={handleTimeZoneChange}
            defaultValue={selectedTimezone && selectedTimezone.timezone}
            showSearch={true}
          >
            {timezones.map((timezone) => {
              const offset = moment.tz(timezone).format('Z');
              return (
                <Option key={timezone} value={timezone}>
                  {timezone} ({offset})
                </Option>
              );
            })}
          </Select>
        </div>
      </Form>
    </Modal>
  );
};

const OffHourSetting = (props) => {
  const { Text } = Typography;
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const [toggleSetting, setToggleSetting] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState({
    timezone: moment.tz.guess(),
    offset: moment.tz(moment.tz.guess()).format('Z'),
  });
  const [customMessage, setCustomMessage] = useState('');
  const params = queryString.parse(props.location.search);
  const channelid = params.channel_id || props.channel_id || null;
  const skill_id = props.match.params.skill_id;
  const wId = props.match.params.wId;
  const commonChanneldata = useSelector(
    (state) => state?.skills?.commonChanneldata
  );
  const channelSettings = commonChanneldata.find(
    (channel) => channel.channel_id === channelid
  );

  useEffect(() => {
    if (channelSettings && channelSettings.offHourConfigForSupport) {
      setToggleSetting(
        channelSettings.offHourConfigForSupport.enableOffHoursInSupport
      );
      setSelectedDays(
        channelSettings.offHourConfigForSupport.offHourConfigs || []
      );
      setSelectedTimezone(
        channelSettings.offHourConfigForSupport.selectedTimezone || {
          timezone: moment.tz.guess(),
          offset: moment.tz(moment.tz.guess()).format('Z'),
        }
      );
      setCustomMessage(
        channelSettings.offHourConfigForSupport.customMessage || ''
      );
    }
  }, [channelSettings, openModal]);

  const handleToggleSetting = (value) => {
    const existingData =
      channelSettings && channelSettings.offHourConfigForSupport;
    let data = {
      offHourConfigForSupport: {
        ...(existingData && { ...existingData }),
        enableOffHoursInSupport: value,
      },
    };
    if (
      value &&
      channelSettings.emojiMarkersDetails &&
      channelSettings.emojiMarkersDetails.issueUnattended &&
      channelSettings.emojiMarkersDetails.issueUnattended.enabled
    ) {
      const allOtherMarkerAreFalse = Object.values(
        channelSettings.emojiMarkersDetails
      )
        .filter(
          (obj) => obj !== channelSettings.emojiMarkersDetails.issueUnattended
        )
        .every((obj) => obj.enabled === false);

      data = {
        ...data,
        ...(allOtherMarkerAreFalse && { emojiMarkers: false }),
        emojiMarkersDetails: {
          ...channelSettings.emojiMarkersDetails,
          issueUnattended: {
            ...channelSettings.emojiMarkersDetails.issueUnattended,
            enabled: false,
          },
        },
      };
      props.handleChangeEmojiMarkerFromOffHour(allOtherMarkerAreFalse);
    }
    setToggleSetting(value);
    dispatch(channelAdminConfig(wId, skill_id, channelid, data));
  };

  const handleConfigOffHours = () => {
    const hasDataWithNoTime = selectedDays.some((item) =>
      item.data.some((timeConfig) => !timeConfig.time || !timeConfig.timeString)
    );
    if (hasDataWithNoTime) {
      const emptyErrorDays = selectedDays.map((item) => {
        const noTimeDataIndex = item.data.findIndex(
          (timeConfig) => !timeConfig.time && !timeConfig.timeString
        );
        return {
          ...item,
          data: item.data.map((timeConfig, index) => ({
            ...timeConfig,
            ...(noTimeDataIndex === index && { error: true }),
          })),
        };
      });
      setSelectedDays(emptyErrorDays);
    } else {
      const existingData =
        channelSettings && channelSettings.offHourConfigForSupport;

      const data = {
        offHourConfigForSupport: {
          ...(existingData && { ...existingData }),
          ...(selectedDays &&
            selectedDays.length && { offHourConfigs: selectedDays }),
          ...(Object.keys(selectedTimezone).length && { selectedTimezone }),
        },
      };
      setOpenModal(false);
      dispatch(channelAdminConfig(wId, skill_id, channelid, data))
        .then(() => {
          message.success('Off hours updated successfully');
        })
        .catch((err) => {
          message.error('Some error occurred. Please try again.');
        });
    }
  };

  const handleSaveCustomMessage = () => {
    const existingData =
      channelSettings && channelSettings.offHourConfigForSupport;
    const data = {
      offHourConfigForSupport: {
        ...(existingData && { ...existingData }),
        customMessage,
      },
    };
    dispatch(channelAdminConfig(wId, skill_id, channelid, data))
      .then(() => {
        message.success('Message updated successfully');
      })
      .catch((err) => {
        message.error('Some error occurred. Please try again.');
      });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedDays([]);
    setSelectedTimezone({});
  };

  const tooltipIcon = (
    <InfoCircleOutlined
      style={{
        marginLeft: 5,
        fontSize: '14px',
      }}
    />
  );

  return (
    <>
      {openModal && (
        <CustomizeModal
          open={openModal}
          handleClose={handleCloseModal}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          setSelectedTimezone={setSelectedTimezone}
          selectedTimezone={selectedTimezone}
          handleConfigOffHours={handleConfigOffHours}
        />
      )}
      <Card
        key={'1'}
        title={
          <div>
            <Text>Off hours settings</Text>
            <Tooltip title="Customize your agent's off hours and its behavior accordingly.">
              {tooltipIcon}
            </Tooltip>
          </div>
        }
        extra={
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Switch
              checked={toggleSetting}
              onClick={() => {
                handleToggleSetting(!toggleSetting);
              }}
            />
          </div>
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Text>Customize off hour days and time</Text>
          <Button
            onClick={() => {
              setOpenModal(true);
            }}
            disabled={!toggleSetting}
          >
            Customize
          </Button>
        </div>
        <div style={{ marginTop: 21 }}>
          <Text>Customize the message sent during off hours</Text>
          <div style={{ display: 'flex', marginTop: 12 }}>
            <TextArea
              value={customMessage}
              rows={2}
              style={{ borderRadius: 2 }}
              onChange={(e) => {
                setCustomMessage(e.target.value);
              }}
              disabled={!toggleSetting}
            />
            <Button
              onClick={handleSaveCustomMessage}
              disabled={!toggleSetting}
              style={{ marginLeft: '1rem' }}
            >
              Save
            </Button>
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <Text type='secondary'>
            Note - Auto creation will be enabled and emoji markers trigger by
            unattended will be disabled.
          </Text>
        </div>
      </Card>
    </>
  );
};

export default withRouter(OffHourSetting);
